module.exports = __webpack_public_path__ + "media/images/image_inv_v2-97585b9b.jpg";